var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Component, Vue } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
const claim = namespace('claim');
const settings = namespace('settings');
let SendMagicLinkAgainButton = class SendMagicLinkAgainButton extends Vue {
    constructor() {
        super(...arguments);
        this.isLoading = false;
    }
    get defaultChannelPreference() {
        const setting = this.getSetting('magicLinkChannelPreference');
        return (setting === null || setting === void 0 ? void 0 : setting.value) || 'default';
    }
    get isDefaultDisabled() {
        return ['no_message', 'none'].includes(this.defaultChannelPreference);
    }
    get options() {
        return [
            {
                value: 'sms_first',
                label: this.$tc('dropdown.options.sms_first.label'),
                description: this.$tc('dropdown.options.sms_first.description'),
                onClick: () => this.sendBySMS(),
            },
            {
                value: 'email_first',
                label: this.$tc('dropdown.options.email_first.label'),
                description: this.$tc('dropdown.options.email_first.description'),
                onClick: () => this.sendByEmail(),
            },
        ];
    }
    async sendAgain() {
        await this.send(this.sendMagicLinkAgain);
    }
    async sendBySMS() {
        await this.send(this.sendMagicLinkBySMS);
    }
    async sendByEmail() {
        await this.send(this.sendMagicLinkByEmail);
    }
    async send(method) {
        try {
            this.isLoading = true;
            const response = await method.call(this);
            this.notify(response);
        }
        catch (error) {
            this.notifyError(error);
        }
        finally {
            this.isLoading = false;
        }
    }
    notify(result) {
        if (result.channelPreference === 'no_message' || result.channelPreference === 'none') {
            // If the preference is set to 'no_message' or 'none', it means that no message was sent, so we show a warning toast.
            return this.$buefy.toast.open({
                type: 'is-warning',
                message: this.$tc('toast.message.no_message'),
            });
        }
        let messageKey;
        let type;
        if (result.channelsSucceeded.length === 0 || result.success === false) {
            // If no channels succeeded or if the overall result is a failure, show an error toast
            type = 'is-danger';
            messageKey = 'toast.message.failure';
        }
        else if (result.channelsAttempted.length === result.channelsSucceeded.length) {
            // If all attempted channels succeeded, show a success toast
            type = 'is-success';
            messageKey = 'toast.message.success';
        }
        else {
            // If some channels succeeded and others failed, show a warning toast
            type = 'is-warning';
            messageKey = ['both', 'default'].includes(result.channelPreference)
                ? // If the preference is 'both' or 'default', it means that all channels were expected, so we show a partial success message.
                    'toast.message.partial'
                : // If the preference is not 'both' or 'default', it means that only one channel was expected, so we show a partial success message with fallback.
                    'toast.message.fallback';
        }
        const appliedChannels = result.channelsSucceeded
            .filter((channel) => result.channelsAttempted.includes(channel))
            .map((channel) => this.$tc(`toast.channel.${channel}`));
        const failedChannels = result.channelsAttempted
            .filter((channel) => !result.channelsSucceeded.includes(channel))
            .map((channel) => this.$tc(`toast.channel.${channel}`));
        const lfc = new Intl.ListFormat(this.$i18n.locale, { type: 'conjunction' });
        const lfd = new Intl.ListFormat(this.$i18n.locale, { type: 'disjunction' });
        const message = this.$tc(messageKey, undefined, {
            appliedChannels: lfc.format(appliedChannels),
            failedChannel: lfd.format(failedChannels),
        });
        this.$buefy.toast.open({ type, message });
    }
    notifyError(_error) {
        // TODO: log error to Sentry or similar
        return this.$buefy.toast.open({
            type: 'is-danger',
            message: this.$tc('toast.message.error'),
        });
    }
};
__decorate([
    claim.Action('sendMagicLinkAgain')
], SendMagicLinkAgainButton.prototype, "sendMagicLinkAgain", void 0);
__decorate([
    claim.Action('sendMagicLinkBySMS')
], SendMagicLinkAgainButton.prototype, "sendMagicLinkBySMS", void 0);
__decorate([
    claim.Action('sendMagicLinkByEmail')
], SendMagicLinkAgainButton.prototype, "sendMagicLinkByEmail", void 0);
__decorate([
    settings.Getter('get')
], SendMagicLinkAgainButton.prototype, "getSetting", void 0);
SendMagicLinkAgainButton = __decorate([
    Component
], SendMagicLinkAgainButton);
export default SendMagicLinkAgainButton;
